import { render, staticRenderFns } from "./ActionsDropdown.vue?vue&type=template&id=2edb30f5&scoped=true&"
import script from "./ActionsDropdown.vue?vue&type=script&lang=js&"
export * from "./ActionsDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2edb30f5",
  null
  
)

export default component.exports